import BrandHome from "@/views/brand/BrandHome";
import CreateStudio from "@/views/brand/CreateStudio";
import BossDirection from "@/views/brand/BossDirection";
import BrandReport from "@/views/brand/BrandReport";
import MyRank from "@/views/brand/MyRank";
import BrandProjectRank from "@/views/brand/BrandProjectRank";
import CompanyRank from "@/views/brand/CompanyRank";
import MyDirection from "@/views/brand/MyDirection";
import StrategyAdvice from "@/views/brand/StrategyAdvice";
import SampleReview from "@/views/brand/SampleReview";

export default [
  { path: "/brand", name: "BrandHome", component: BrandHome, meta: { brand: true } },
  { path: "/brand/create", name: "BrandCreateStudio", component: CreateStudio, meta: { brand: true } },
  { path: "/brand/direction", name: "BrandBossDirection", component: BossDirection, meta: { brand: true } },
  { path: "/brand/report", name: "BrandReport", component: BrandReport, meta: { brand: true } },
  { path: "/brand/rank/me", name: "BrandMyRank", component: MyRank, meta: { brand: true } },
  { path: "/brand/rank/projects", name: "BrandProjectRank", component: BrandProjectRank, meta: { brand: true } },
  { path: "/brand/rank/company", name: "BrandCompanyRank", component: CompanyRank, meta: { brand: true } },
  { path: "/brand/direction/me", name: "BrandMyDirection", component: MyDirection, meta: { brand: true } },
  { path: "/brand/strategy", name: "BrandStrategyAdvice", component: StrategyAdvice, meta: { brand: true } },
  { path: "/brand/samples", name: "BrandSampleReview", component: SampleReview, meta: { brand: true } }
];



// WEBPACK FOOTER //
// ./src/router/brand.js